import CardCommon from '@op/components/CardCommon';
import { DefaultImg } from '@op/constants/defaultImg';
import useIntls from '@opm/hooks/useIntls';
import {
  IHashtagAISummaryFilter,
  useHashtagAISummary,
} from '@opm/pages/Hashtag/hooks/useHashtagAISummary';
import React, { useMemo } from 'react';
import './index.scss';

interface IHashtagAISummaryProps {
  filter?: IHashtagAISummaryFilter;
  className?: string;
}

export default function HashtagAISummary(props: IHashtagAISummaryProps) {
  const { filter, className = '' } = props;
  const { intl, isEn } = useIntls();

  const { data, loading } = useHashtagAISummary({ filter });

  const summaryText = useMemo(
    () => (isEn ? data?.summary_en : data?.summary_zh),
    [isEn, data?.summary_en, data?.summary_zh],
  );

  if(!summaryText || loading){
    return null;
  }

  return (
    <CardCommon
      className={`dbom-hashtag-ai-summary ${className}`}
      title={(
        <div className="dbom-hashtag-ai-summary__header">
          <img
            src={DefaultImg.AI}
            className="dbom-hashtag-ai-summary__icon"
            alt="AI"
          />
          <span className="dbom-hashtag-ai-summary__title">
            {intl('AI Summary')}
          </span>
        </div>
      )}
      loading={loading}
      loadingHeight={60}
      empty={!summaryText}
      emptyHeight={60}
      hasEmptyImg={false}
      hasEmptyTitle={false}
      emptyDescText={intl('No summary available yet')}
      contentCard
    >
      <div className="dbom-hashtag-ai-summary__content">{summaryText}</div>
    </CardCommon>
  );
}
